<template>
  <div class="container-entities">
    <p>
      Importa los datos de tus contactos y sus productos.
      <a :href="DOCS_URL" target="_blank" rel="noopener noreferrer">Click aquí</a> para conocer más.
    </p>
    <a-row class="controls" type="flex" justify="space-between">
      <a-col>
        <a-form layout="inline">
          <entity-picker
            class="entity__picker"
            :value="entity"
            @update:value="entity = $event"
            v-if="user?.customer?.type_business == 1"
          />
          <campaign-picker
            :value="portfolio"
            @update:value="portfolio = $event"
            :entity="entity"
            class="campaign__picker"
          />
        </a-form>
      </a-col>

      <a-col>
        <a-row type="flex">
          <DownloadTemplate :value="downloadModal" @update:value="downloadModal = $event" />

          <div>
            <InfoCircleOutlined class="tooltip__icon" />
            <a-button
              type="link"
              class="button--left"
              id="import-predefined-templates"
              @click="handleShowDrawer"
            >
              Plantillas predefinidas
            </a-button>

            <a-tooltip :title="hasAPendingImport ? 'Tiene una importación pendiente' : null">
              <a-button
                type="primary"
                id="new-import-btn"
                :disabled="hasAPendingImport"
                @click="handleShowNewImportModal"
              >
                Nueva importación
              </a-button>
            </a-tooltip>
          </div>
        </a-row>
      </a-col>
    </a-row>

    <TableImports />

    <ModalNewImport
      :modelValue="selectorModal"
      @update:modelValue="selectorModal = $event"
      @select:clients="handleClientsSelect"
      @select:massive="handleMassiveSelect"
      @onOpenModalProducts="handleOpenModalProducts"
      @onOpenModalProcess="handleOpenModalProcess"
    />

    <ModalClientProduct
      :modelValue="clientsModal"
      @update:modelValue="clientsModal = $event"
      :isTypeBusiness="isTypeBusiness"
      v-if="openProducts"
      @onHideModalProducts="handleHideModalProducts"
      @onReturnModal="handleOpenModalGeneral"
    />

    <ModalTypeProcess
      :modelValue="massiveModal"
      @update:modelValue="massiveModal = $event"
      @select:import="handleImportSelect"
      v-if="openProcess"
      @onHideModalProcess="handleHideModalProcess"
      @onReturnModal="handleOpenModalGeneral"
    />
    <ModalProcess
      :isTypeBusiness="isTypeBusiness"
      :modelValue="processModal"
      @update:modelValue="processModal = $event"
      :import-type="importType"
      v-if="processModal"
      @onModalProcessMasive="openProcessModal"
    />
  </div>
</template>

<script>
import EntityPicker from "@/app/shared/components/pickers/EntityPicker.vue";
import CampaignPicker from "@/app/shared/components/pickers/CampaignPicker.vue";
import ModalClientProduct from "@/app/imports/components/modals/modalImports/importClientProducts/ModalClientProduct.vue";
import ModalTypeProcess from "@/app/imports/components/modals/modalImports/importProcess/ModalTypeProcess.vue";
import ModalProcess from "@/app/imports/components/modals/modalImports/importProcess/ModalProcess.vue";
import DownloadTemplate from "@/app/imports/components/modals/modalImports/downloadTemplates/DownloadTemplate.vue";
import ModalNewImport from "@/app/imports/components/modals/modalImports/ModalNewImport.vue";
import TableImports from "@/app/imports/components/tables/TableImports.vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";
import { defineComponent, ref, computed, watch } from "vue";
import { useStore } from "vuex";

export default defineComponent({
  components: {
    EntityPicker,
    CampaignPicker,
    ModalClientProduct,
    ModalTypeProcess,
    ModalProcess,
    DownloadTemplate,
    ModalNewImport,
    TableImports,
    InfoCircleOutlined,
  },
  setup() {
    const store = useStore();
    const user = computed(() => store.getters["getDataUser"]);
    const isTypeBusiness = computed(() => user.value?.customer?.type_business == 2);
    const entity = ref(0);

    if (user.value) {
      if (user.value.customer.type_business == 2) {
        entity.value = 1;
      }
    }

    const hasAPendingImport = computed(() => {
      const importsList = store.getters["getFilteredImports"];

      return importsList.some((importItem) => importItem.status_name === "En espera");
    });

    watch(user, (newValue) => {
      if (newValue.customer.type_business == 2) {
        entity.value = 1;
      }
    });
    return {
      entity,
      user,
      isTypeBusiness,
      hasAPendingImport,
    };
  },
  data() {
    const DOCS_URL = `${import.meta.env.VITE_WEB_DOC}/crm/importaciones-1/`;

    return {
      portfolio: 0,
      importType: 0,

      selectorModal: false,
      clientsModal: false,
      massiveModal: false,
      processModal: false,
      downloadModal: false,
      openProducts: false,
      openProcess: false,
      DOCS_URL: DOCS_URL,
    };
  },
  watch: {
    entity() {
      this.handleSearch();
    },
    portfolio() {
      this.handleSearch();
    },
  },
  sockets: {
    refreshImport(data) {
      if (!this.$store.getters.isSocketEventForCurrentUser(data)) return;
      this.fetchImports();
    },
  },
  created() {
    this.fetchImports();
    this.$store.dispatch("fetchAllEntities");
  },
  methods: {
    handleSearch() {
      const filters = {
        entity: this.entity,
        portfolio: this.portfolio,
      };
      this.$store.dispatch("fetchAllImports", filters);
    },
    handleImportSelect(importType) {
      this.importType = importType;
      this.processModal = true;
    },
    handleClientsSelect() {
      this.clientsModal = true;
    },
    handleMassiveSelect() {
      this.massiveModal = true;
    },
    handleShowNewImportModal() {
      this.selectorModal = true;
    },
    handleShowDrawer() {
      this.downloadModal = true;
    },
    fetchImports() {
      this.$store.dispatch("fetchAllImports");
    },
    handleOpenModalProducts(e) {
      this.openProducts = e;
    },
    handleHideModalProducts() {
      this.openProducts = false;
    },
    handleOpenModalProcess(e) {
      this.openProcess = e;
    },
    handleHideModalProcess() {
      this.openProcess = false;
    },
    handleOpenModalGeneral() {
      this.openProducts = false;
      this.openProcess = false;
      this.selectorModal = true;
    },
    openProcessModal() {
      this.processModal = false;
      this.openProcess = true;
    },
  },
});
</script>

<style lang="sass" scoped>
.ant-form-item
  margin-bottom: 20px

.tooltip
  &__icon
    margin: 8px 4px 0 0
    color: $blue-6


.button
  &--left
    padding-left: 0

.container-entities
  padding: 8px 20px

.controls
  margin-bottom: 8px

.entradaBoton
  display: flex
  justify-content: space-between
  margin-top: 20px
  margin-bottom: 24px
  widows: 100%

.entity__picker
  width: 174px

.campaign__picker
  width: 180px !important
</style>
